var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "14px",
    viewBox: "0 0 23 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "account-group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Managers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconen-drukke-dagen",
    transform: "translate(-24.000000, -20.000000)",
    fill: "#FF8100",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "account-group",
    transform: "translate(24.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2,0.466666667 C13.0041302,0.466666667 14.4666667,1.92920315 14.4666667,3.73333333 C14.4666667,5.53746352 13.0041302,7 11.2,7 C9.39586982,7 7.93333333,5.53746352 7.93333333,3.73333333 C7.93333333,1.92920315 9.39586982,0.466666667 11.2,0.466666667 M4.66666667,2.8 C5.18933333,2.8 5.67466667,2.94 6.09466667,3.192 C5.95466667,4.52666667 6.34666667,5.852 7.14933333,6.888 C6.68266667,7.784 5.74933333,8.4 4.66666667,8.4 C3.12026937,8.4 1.86666667,7.1463973 1.86666667,5.6 C1.86666667,4.0536027 3.12026937,2.8 4.66666667,2.8 M17.7333333,2.8 C19.2797306,2.8 20.5333333,4.0536027 20.5333333,5.6 C20.5333333,7.1463973 19.2797306,8.4 17.7333333,8.4 C16.6506667,8.4 15.7173333,7.784 15.2506667,6.888 C16.0533333,5.852 16.4453333,4.52666667 16.3053333,3.192 C16.7253333,2.94 17.2106667,2.8 17.7333333,2.8 M5.13333333,12.3666667 C5.13333333,10.4346667 7.84933333,8.86666667 11.2,8.86666667 C14.5506667,8.86666667 17.2666667,10.4346667 17.2666667,12.3666667 L17.2666667,14 L5.13333333,14 L5.13333333,12.3666667 M0,14 L0,12.6 C0,11.3026667 1.764,10.2106667 4.15333333,9.89333333 C3.60266667,10.528 3.26666667,11.4053333 3.26666667,12.3666667 L3.26666667,14 L0,14 M22.4,14 L19.1333333,14 L19.1333333,12.3666667 C19.1333333,11.4053333 18.7973333,10.528 18.2466667,9.89333333 C20.636,10.2106667 22.4,11.3026667 22.4,12.6 L22.4,14 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.435c4e3f80d029684875640b02c4f7f9.svg";
export { ForwardRef as ReactComponent };